<template>
	<div class="admin-import">
		<h1 class="admin-import__header">
			<div class="admin-import__title">
				<Icon type="team" />
				Импортированные пользователи
			</div>

			<!-- <a-anchor class="admin-import__anchor" :targetOffset="80">
				<a-anchor-link href="#user-table-import-not-linked" title="Не обработаны" />
				<a-anchor-link href="#user-table-import-linked" title="Обработаны" />
			</a-anchor> -->
		</h1>

		<UserTableImport
			class="admin-import__table"
			:isLoading="isLoading"
			:users="importedUsers"
			:coreUsers="coreUsers"
			@refresh="getImportedUsers()"
		/>
	</div>
</template>

<script>
import { Icon } from "ant-design-vue"

export default {
	name: "AdminImport",

	components: {
		Icon,
		UserTableImport: () => import("@/components/UserTableImport")
	},

	data() {
		return {
			importedUsers: [],
			coreUsers: [],
			isLoading: false
		}
	},

	methods: {
		/**
		 * Получить импортированных пользователей
		 */
		async getImportedUsers() {
			this.isLoading = true

			try {
				this.importedUsers = await this.$context.adminImportedUserService.getUsers()
			} catch (message) {
				this.$alert.error(message)
			}

			this.isLoading = false
		},

		/**
		 * Получить список одеск айдишников
		 */
		async getCoreUsers() {
			try {
				this.coreUsers = await this.$context.adminUserService.getUsers()
			} catch (message) {
				this.$alert.error(message)
			}
		}
	},

	mounted() {
		this.getImportedUsers()
		this.getCoreUsers()
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars";

.admin-import {
	&__header {
		display: flex;
		justify-content: space-between;
	}

	&__title {
		font-size: 22px;
	}
}
</style>
